import React from "react";
// External
import LinearProgress from "@mui/material/LinearProgress";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import makeStyles from "@mui/styles/makeStyles";
var useStyles = makeStyles(function (_a) {
    var spacing = _a.spacing;
    return ({
        loadingCell: {
            borderBottom: "none",
            height: "".concat(spacing(0.5), " !important"),
        },
    });
});
export default (function (_a) {
    var colSpan = _a.colSpan;
    var classes = useStyles();
    return (React.createElement(TableRow, null,
        React.createElement(TableCell, { className: classes.loadingCell, colSpan: colSpan, padding: "none" },
            React.createElement(LinearProgress, null))));
});
//# sourceMappingURL=LoadingRow.js.map